var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      attrs: {
        id: "extended-fact-sheet-container",
        flex: "",
        flat: "",
        width: _vm.width
      },
      model: {
        value: _vm.itemId,
        callback: function($$v) {
          _vm.itemId = $$v
        },
        expression: "itemId"
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { "ml-5": "", grow: "" } },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _c(
                "v-list",
                {
                  staticClass: "fact-sheet-list",
                  attrs: { dense: "", flat: "" }
                },
                [
                  _c(
                    "v-list-tile",
                    { staticClass: "fact-sheet-header extended-header" },
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.displayItem.label) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.displayItem.labelAlt
                            ? _c("v-list-tile-sub-title", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.displayItem.labelAlt) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("close-extended")
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card",
            {
              staticClass: "extended-content",
              attrs: { flat: "", "max-height": _vm.extendedHeight }
            },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        flat: "",
                        "max-width": "650",
                        "min-height": "20"
                      }
                    },
                    [
                      _vm.displayItem.description
                        ? _c("v-card-text", [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.displayItem.description) +
                                "\n        "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      staticClass: "meta-info",
                      attrs: { flat: "", "max-width": "550" }
                    },
                    _vm._l(_vm.displayItem.metaInfo, function(info, index) {
                      return _c(
                        "v-list",
                        { key: index, attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-tile",
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _c("v-list-tile-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(info.label) +
                                        "\n              "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  info.id === "web"
                                    ? _c(
                                        "v-list-tile-sub-title",
                                        { attrs: { id: "extended-cutoff" } },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: info.url,
                                                target: "_blank"
                                              }
                                            },
                                            [_vm._v(_vm._s(info.name))]
                                          )
                                        ]
                                      )
                                    : info.id === "loc"
                                      ? _c(
                                          "v-list-tile-sub-title",
                                          {
                                            domProps: {
                                              innerHTML: _vm._s(info.value)
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              x\n              "
                                            )
                                          ]
                                        )
                                      : _c("v-list-tile-sub-title", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(info.value) +
                                              "\n              "
                                          )
                                        ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4917cd75", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4917cd75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FactSheet_Extended.vue
// module id = null
// module chunks = 